import type { DispersionsTranslations } from "../interfaces/dispersions";

export const dispersionsTranslations: DispersionsTranslations = {
  header_title: "Enviar dinero",
  header_subtitle: "De forma inmediata y directa a quien lo recibe",
  header_chip: "Nuevo envío",
  step_1_title: "Conversión de Moneda",
  step_2_title: "Información del Destinatario",
  step_3_title: "Confirmación",
  stepper_amount: "Monto",
  stepper_recipient: "Destinatario",
  stepper_review: "Revisión",

  balance_label: "Saldo Disponible",

  origin_currency_label: "Moneda Origen",
  destination_currency_label: "Moneda Destino",
  select_origin_currency: "Selecciona moneda origen",
  select_destination_currency: "Selecciona moneda destino",
  origin_country_label: "País de Origen",
  destination_country_label: "País de Destino",
  amount_origin_label: "Monto a Enviar",
  amount_destination_label: "Monto a Recibir",
  conversion_rate_label: "Tasa de Conversión",
  amount_to_send: "Monto a Enviar",
  amount_to_receive: "Monto a Recibir",
  fees_label: "Comisión",
  total_deducted_label: "Total a Descontar",

  fields: {
    phone_number: "Número de Teléfono",
    key_number: "Llave",
    pix_type: "Tipo de Clave PIX",
    pix_key: "Clave PIX",
    description: "Descripción",
    clabe: "CLABE",
    recipient: "Destinatario",
    protocol: "Protocolo",
    first_name: "Nombre",
    last_name: "Apellido",
    identification_type: "Tipo de Identificación",
    identification_number: "Número de Identificación",
    bank: "Banco",
    account_type: "Tipo de Cuenta",
    account_number: "Número de Cuenta",
    address: "Dirección",
    city: "Ciudad",
    state: "Estado/Provincia",
    postal_code: "Código Postal",
    birth_date: "Fecha de Nacimiento",
    email: "Correo Electrónico",
    gender: "Género",
    webhook_url: "URL de Webhook",
    full_name: "Nombre Completo",
    document_type: "Tipo de Documento",
    document_number: "Número de Documento",
    network: "Red",
    wallet: "Wallet",
  },

  placeholders: {
    phone_number: "Ej: 3001234567",
    key_number: "Ej: 3113113113",
    pix_key: "Ingrese su clave PIX",
    description: "Ingrese una descripción (opcional)",
    clabe_mexico: "646180110400000007",
    recipient: "Juan Pérez",
    account_number: "Ingrese el número de cuenta",
    email: "correo@ejemplo.com",
    first_name: "Juan",
    last_name: "Pérez",
    identification_type: "RUT",
    identification_number: "12345678-9",
    address: "Av. Principal 123",
    city: "Santiago",
    state: "Metropolitana",
    postal_code: "7500000",
    full_name: "Juan Pérez González",
    document_number: "1234567890",
    wallet: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb",
    webhook_url: "https://api.ejemplo.com/webhook/dispersion",
  },

  helpers: {
    phone_number_colombia: "Debe ser un número de 10 dígitos",
    key_number_colombia: "Debe ser una llave numérica de 10 dígitos",
    pix_key_cpf: "Ingrese 11 dígitos del CPF sin formato",
    pix_key_cnpj: "Ingrese 14 dígitos del CNPJ sin formato",
    pix_key_email: "Ingrese un email válido en minúsculas",
    pix_key_phone: "Ingrese 9 dígitos del teléfono",
    pix_key_evp: "Ingrese el UUID en formato válido",
    clabe_18_digits: "Debe contener exactamente 18 dígitos",
    webhook_url: "URL para recibir notificaciones (máximo 255 caracteres)",
    document_number_ecuador: "CEDULA: 10 dígitos, RUC: 13 dígitos, PASAPORTE: 6-9 caracteres",
    identification_number_panama: "CIP: 8 dígitos, PASAPORTE: 9 caracteres alfanuméricos",
    wallet_address: "Dirección de wallet de destino",
  },

  button_next: "Siguiente",
  button_previous: "Anterior",
  button_confirm: "Confirmar",
  button_cancel: "Cancelar",
  button_retry: "Reintentar",
  button_continue: "Continuar",
  button_authorize: "Autorizar envío",

  twofa_modal_title: "Verificación de dos factores",
  twofa_modal_instruction:
    "Ingresa el código de 6 dígitos de tu aplicación de autenticación para confirmar este envío.",
  twofa_verifying: "Verificando...",

  recipient_client_label: "Cliente",
  recipient_client_loading: "Cargando clientes…",
  recipient_client_placeholder: "Buscar cliente por nombre...",
  recipient_account_label: "Cuenta del cliente",
  recipient_account_loading: "Cargando cuentas…",
  recipient_account_placeholder: "Seleccionar cuenta...",
  recipient_account_fallback_name: "Cuenta",
  recipient_pix_type_label: "Tipo de clave PIX",
  recipient_pix_type_placeholder: "Selecciona tipo de clave...",
  recipient_description_label: "Descripción",
  recipient_description_placeholder: "Descripción del envío",
  footer_rate_note: "Los importes quedan fijos con la tasa de esta cotización hasta que expire.",

  error_create_failed: "No pudimos crear el envío",
  error_client_required: "Selecciona un cliente",
  error_client_account_required: "Selecciona una cuenta del cliente",
  error_description_required: "La descripción es obligatoria",
  error_pix_key_invalid: "Ingresa una clave PIX válida",
  error_recipient_name_required: "Ingresa el nombre del destinatario",
  error_clabe_invalid: "Ingresa una CLABE válida de 18 dígitos",
  error_cbu_cvu_invalid: "Ingresa un CBU/CVU válido de 22 dígitos",
  error_cuit_invalid: "El CUIT/CUIL debe tener 11 dígitos",
  error_breb_key_invalid: "Ingresa una llave Bre-B válida",
  error_no_organization: "Tu usuario no tiene una organización asociada para crear el envío.",
  error_payment_rejected:
    "El pago fue rechazado por el banco destino. Verifica los datos del destinatario e inténtalo nuevamente.",
  error_origin_required: "Selecciona la moneda de origen",
  error_destination_required: "Selecciona la moneda de destino",
  error_amount_required: "Ingresa un monto",
  error_amount_positive: "El monto debe ser mayor a 0",
  loading_quote: "Obteniendo cotización...",
  loading_balance: "Cargando saldo...",

  confirmation_review_title: "Revisa los Detalles",
  confirmation_amount_section: "Información del Monto",
  confirmation_recipient_section: "Información del Destinatario",

  step_conversion_title: "Conversión",
  step_recipient_title: "Destinatario",
  step_confirmation_title: "Confirmación",

  quote_valid_for: "Esta tasa es válida por",
  quote_expiring_soon: "La cotización expirará pronto",
  quote_expired_message: "La cotización ha expirado",
  quote_expired_modal_title: "Cotización Expirada",
  quote_expired_modal_message:
    "La tasa de cambio ha expirado. Para continuar con tu envío, necesitas recalcular la cotización con las tasas actuales.",
  quote_expired_modal_hint: "También puedes volver al inicio si deseas cambiar los montos o destinos.",
  quote_expired_recalculate: "Recalcular Cotización",
  quote_expired_start_over: "Volver al Inicio",

  register_client_button: "Registrar cliente",
  client_kyc_blocked_note:
    "El cliente seleccionado aún no ha completado la verificación de identidad (KYC). No podrás continuar con el envío hasta que esté verificado.",
  client_kyc_unavailable_note:
    "No pudimos verificar el estado de identidad (KYC) de tus clientes. Por seguridad, no es posible continuar con el envío hasta completar la verificación.",
  client_kyc_retry_button: "Reintentar verificación",
  register_account_button: "Registrar cuenta",
  client_not_verified_badge: "No verificado",
  recipient_use_client_label: "Enviar a un cliente registrado",
  recipient_manual_hint: "Escribe los datos de quien recibe. No necesitas tenerlo registrado.",
  recipient_use_client_hint: "Elige un cliente y completamos sus datos de cobro.",
  step1_no_wallets_note: "No tienes billeteras activas. Actívalas en Billeteras para poder enviar.",
  step1_origin_wallet_frozen_badge: "Congelada",
  step1_cross_currency_hint:
    "Convertimos de {{origin}} a {{destination}} al confirmar; la tasa queda fija en esta cotización.",
  step1_same_currency_hint: "Envías y el destinatario recibe en {{currency}}: no hay conversión.",
  runtime_wallet_missing: "No tienes una billetera en {{currency}}. Actívala en Billeteras.",
  quote_breakdown_title: "Desglose de la cotización",
  quote_conversion_fee_label: "Comisión de conversión",
  quote_converted_amount_label: "Monto convertido",
  quote_dispersion_fee_label: "Comisión de envío",
  quote_recalculated_note: "Actualizamos los importes con la tasa vigente. Revísalos antes de autorizar.",
  error_quote_required: "Necesitamos una cotización vigente para autorizar el envío.",
  error_quote_expired: "La cotización expiró. Recalcúlala para continuar.",
  error_quote_pricing: "Estamos actualizando la cotización. Espera un momento.",
  error_quote_already_used: "Esta cotización ya fue utilizada. Revisa tu historial antes de reintentar.",
  error_payout_unconfirmed:
    "No pudimos confirmar el estado de esta operación. Revísala en tu historial antes de reintentar.",
  result_error_check_activity: "Ver historial de actividad",
  error_verification_required:
    "Tu cuenta aún no está verificada. Completa la verificación para poder enviar dinero.",
  result_error_go_verify: "Ir a la verificación",
  error_quote_invalid: "No pudimos usar esta cotización. Recalcúlala e inténtalo nuevamente.",
  error_unsupported_corridor: "Este corredor no está disponible para envíos.",
  runtime_wallet_frozen_warning:
    "Tu billetera {{currency}} está congelada: no es posible enviar dinero por ahora.",
  runtime_insufficient_funds: "Saldo insuficiente en tu billetera {{currency}}. Puedes enviar hasta {{max}}.",
  runtime_balance_error: "No pudimos cargar el saldo de tu billetera {{currency}}.",

  result_processing_title: "Enviando tu dinero…",
  result_processing_subtitle: "Estamos haciendo el envío. Esto toma unos segundos.",
  result_status_created: "Pendiente de envío",
  result_status_paid: "Entregado",
  result_status_processing: "Procesando en el banco",
  result_status_failed: "Rechazado",
  result_status_cancelled: "Cancelado",
  result_status_reversed: "Devuelto",
  result_success_title: "Envío realizado",
  result_pending_title: "Envío en camino",
  result_rejected_title: "El envío no se completó",
  result_receipt_to: "para",
  result_success_sent_note: "El dinero ya está en su cuenta.",
  result_success_created_note: "Quedó registrado y sale en breve.",
  result_pending_sent_note: "Falta la confirmación del banco destino.",
  result_rejected_note: "El dinero volvió a tu billetera.",
  result_rejected_note_converted:
    "El dinero quedó disponible en tu billetera de {{currency}}, no en la de origen: la conversión ya se había hecho y no se revierte. La comisión de conversión no se reintegra.",
  result_pending_live_hint: "Esta pantalla se actualiza sola en cuanto el banco confirme el envío.",
  result_reference_label: "Referencia",
  result_reference_copy: "Copiar la referencia",
  result_reference_copied: "Referencia copiada",
  route_label: "Ruta",
  send_label: "Envías",
  concept_label: "Concepto",
  result_show_details: "Ver detalles",
  result_hide_details: "Ocultar detalles",
  receipt_save_recipient: "Guardar este destinatario",
  receipt_save_recipient_done: "Guardado. La próxima vez lo eliges de tu lista de clientes.",
  receipt_save_recipient_partial:
    "Creamos el cliente, pero su cuenta quedó sin guardar. Puedes agregarla desde Clientes.",
  result_send_again: "Enviar nuevamente",
  result_send_again_pending_hint:
    "Disponible cuando el envío se resuelva. Repetirlo ahora sería un segundo pago al mismo destinatario.",
  result_send_to_someone_else: "Enviar a otra persona",
  result_back_to_wallets: "Volver a mis billeteras",
  result_error_title: "No pudimos enviar el dinero",
  result_error_fallback: "Verifica los datos del destinatario o intenta nuevamente en unos minutos.",
  result_error_adjust: "Ajustar datos",

  quote_rate_valid_for: "Tasa válida por",
  quote_receives_label: "Recibe:",
  quote_exchange_rate_label: "Tipo de cambio",
  quote_total_debit_label: "Total a debitar de tu cuenta",
  quote_recipient_receives_label: "El destinatario recibe",

  rail_label: "Riel",
  rail_transfer: "Transferencia",
  rail_crypto: "Cripto",

  step1_origin_label: "Envías desde",
  step1_destination_label: "El destinatario recibe en",
  step1_select_placeholder: "Selecciona…",
  step1_origin_account_title: "Cuenta de origen",
  step1_available_balance: "Saldo disponible",
  step1_refresh_balance: "Actualizar saldo",
  step1_amount_placeholder: "0,00",
  step1_amounts_hint: "Edita cualquiera de los dos — el otro se calcula con la tasa.",
  step1_quote_loading: "Calculando tasa…",
  step1_quote_error: "No pudimos obtener la tasa.",
  error_amount_above_max: "El monto supera el máximo de {{limit}} para este corredor.",
  error_amount_below_min: "El monto está por debajo del mínimo de {{limit}} para este corredor.",
  step1_limit_hint_range: "Este corredor admite de {{min}} a {{max}} por envío.",
  step1_limit_hint_max: "Este corredor admite hasta {{max}} por envío.",
  step1_limit_hint_min: "Este corredor exige al menos {{min}} por envío.",
  step2_limit_blocked:
    "Con este método y destinatario el monto queda fuera del límite permitido ({{limit}}). Ajusta el monto para continuar.",
  step2_limit_back: "Volver al monto",

  step2_client_label: "Cliente",
  step2_client_loading_placeholder: "Cargando clientes…",
  step2_client_placeholder: "Selecciona un cliente…",
  step2_account_label: "Cuenta del destinatario ({{currency}})",
  step2_account_placeholder: "Selecciona una cuenta…",
  step2_account_fallback_label: "Cuenta",
  step2_no_accounts_note: "Este cliente no tiene cuentas en {{currency}}.",
  step2_recipient_section_title: "Quién va a recibir el dinero",
  step2_recipient_name_label: "Nombre del destinatario",
  step2_recipient_name_placeholder: "Nombre completo o razón social",
  step2_concept_placeholder: "Pago a proveedor · factura 1042",
  step2_separator_brazil: "DATOS DEL DESTINO · BRASIL → PIX",
  step2_separator_mexico: "DATOS DEL DESTINO · MÉXICO → SPEI",
  step2_separator_argentina: "DATOS DEL DESTINO · ARGENTINA → CBU/CVU",
  step2_pix_type_label: "Tipo de clave PIX",
  step2_clabe_placeholder: "18 dígitos",
  step2_clabe_error: "La CLABE debe tener 18 dígitos.",
  step2_clabe_helper: "18 dígitos, sin espacios ni guiones.",
  step2_account_type_cvu: "CVU (billetera)",
  step2_account_type_cbu: "CBU (banco)",
  step2_cbu_cvu_placeholder: "22 dígitos",
  step2_cbu_cvu_error: "El {{type}} debe tener 22 dígitos.",
  step2_cbu_cvu_helper: "22 dígitos, sin espacios ni guiones.",
  step2_cuit_label: "CUIT/CUIL del destinatario",
  step2_cuit_placeholder: "11 dígitos, sin guiones",
  step2_cuit_error: "El CUIT/CUIL debe tener 11 dígitos.",
  step2_cuit_helper: "Opcional. Ayuda al banco destino a validar el titular.",
  // Colombia · TRANSFIYA (ACH en línea)
  step2_col_rail_label: "Método de envío",
  col_rail_breb: "Llave Bre-B",
  col_rail_transfiya: "Cuenta bancaria (Transfiya)",
  col_rail_unavailable: "En mantenimiento. Esperamos tenerlo activo pronto.",
  col_rail_not_configured: "No disponible por ahora para tu organización.",
  col_rail_balance_low: "Temporalmente deshabilitado. Intenta con otro método.",
  col_rail_balance_low_try_breb: "Temporalmente deshabilitado. Intenta por Bre-B.",
  step2_separator_colombia_transfiya: "DATOS DEL DESTINO · COLOMBIA → TRANSFIYA",
  step2_tf_bank_label: "Banco destino",
  step2_tf_bank_placeholder: "Selecciona un banco",
  step2_tf_bank_loading: "Cargando bancos…",
  step2_tf_bank_error: "No se pudo cargar la lista de bancos. Recarga la página.",
  step2_tf_account_type_label: "Tipo de cuenta",
  tf_account_type_savings: "Ahorros",
  tf_account_type_checking: "Corriente",
  tf_account_type_deposit: "Depósito bajo monto",
  tf_account_type_standard_deposit: "Depósito ordinario",
  tf_account_type_inclusive_deposit: "Depósito inclusivo",
  step2_tf_account_number_label: "Número de cuenta",
  step2_tf_account_number_placeholder: "Solo números",
  step2_tf_doc_type_label: "Tipo doc.",
  step2_tf_doc_number_label: "Documento del destinatario",
  step2_tf_doc_number_placeholder: "Solo números",
  error_tf_account_number_invalid: "Ingresa un número de cuenta válido",
  error_tf_bank_required: "Selecciona el banco destino",
  error_tf_doc_number_invalid: "Ingresa el documento del destinatario",
  step3_tf_bank_label: "Banco destino",
  step3_tf_account_label: "Cuenta",
  step3_tf_doc_label: "Documento",
  step2_breb_key_label: "Llave Bre-B",
  step2_breb_key_helper: "Debe estar registrada como llave Bre-B de quien recibe.",
  step2_breb_key_placeholder_phone: "3001234567",
  step2_breb_key_placeholder_email: "correo@ejemplo.com",
  step2_breb_key_placeholder_alphanum: "@llave",
  step2_breb_key_placeholder_nric: "Número de documento",
  step2_breb_key_placeholder_merchant: "Código de comercio",
  step2_breb_key_error_phone:
    "Ingresa el celular de 10 dígitos tal como está registrado, sin espacios ni +57.",
  step2_breb_key_error_email: "Ingresa un correo válido.",
  step2_breb_key_error_alphanum: "Ingresa una llave alfanumérica válida.",
  step2_breb_key_error_nric: "Ingresa el documento tal como está registrado, sin puntos ni espacios.",
  step2_breb_key_error_merchant: "Ingresa un código de comercio válido.",
  breb_key_type_phone: "Celular",
  breb_key_type_email: "Correo",
  breb_key_type_alphanum: "Alfanumérica",
  breb_key_type_nric: "Documento",
  breb_key_type_merchant: "Código de comercio",
  breb_lookup_loading: "Consultando la llave en el directorio Bre-B…",
  breb_recipient_idle: "Escribe la llave y te decimos quién la tiene",
  breb_recipient_confirmed: "Titular verificado en {{bank}}",
  breb_recipient_no_holder: "La llave está activa, pero el directorio no devolvió el nombre",
  breb_recipient_holder_line: "{{holder}} · {{bank}}",
  breb_recipient_saved_as: "Guardado en tus clientes como {{name}}",
  breb_status_unknown: "No pudimos confirmar el estado de la llave",
  breb_lookup_not_found_detail: "Verifica la llave con quien va a recibir el dinero.",
  breb_lookup_unavailable_detail: "Sin confirmar quién recibe no se puede enviar. Inténtalo en unos minutos.",

  breb_lookup_inactive: "La llave existe pero no está activa. El envío sería rechazado.",
  breb_lookup_not_found: "Esta llave no está registrada en Bre-B",
  breb_lookup_unavailable: "No pudimos consultar el directorio Bre-B",
  step3_breb_holder_label: "Titular verificado",
  step3_breb_bank_label: "Entidad",

  step3_summary_title: "Resumen de la operación",
  step3_recipient_title: "Quién recibe",
  step3_name_label: "Nombre",
  step3_clabe_label: "CLABE",
  step3_account_type_label: "Tipo de cuenta",
  step3_cuit_label: "CUIT/CUIL",
  step3_breb_key_type_label: "Tipo de llave",
  step3_pix_type_label: "Tipo de clave",
  step3_pix_key_label: "Clave PIX",
  step3_pix_type_email: "Correo",
  step3_pix_type_phone: "Teléfono",
  step3_pix_type_evp: "Clave aleatoria",
  step3_irreversible_prefix: "Una vez autorizado, el envío es",
  step3_irreversible_emphasis: "inmediato e irreversible",

  send_title: "Enviar dinero",
  send_subtitle: "Desde tu billetera {{currency}}",
  send_from_label: "Desde",
  send_from_wallet: "Billetera {{currency}}",
  send_available: "Disponible {{amount}}",
  send_to_label: "Hacia",
  send_amount_label: "¿Cuánto vas a enviar?",
  send_fee_switch: "Yo asumo el costo del envío",
  send_fee_on_hint: "La persona recibe el monto completo; el costo se suma a lo que sale de tu billetera.",
  send_fee_off_hint: "El costo se descuenta de lo que recibe la persona.",
  send_row_arrives: "Llega a la persona",
  send_row_cost: "Costo del envío",
  send_row_debit: "Sale de tu billetera",
  send_cost_free: "Sin costo",
  send_insufficient: "No te alcanza: tienes {{balance}} disponibles y este envío necesita {{debit}}.",
  send_quote_error: "No pudimos calcular el envío. Inténtalo de nuevo.",
  send_rail_label: "¿Cómo lo envías?",
  send_rail_breb_hint: "Llega en segundos a una llave",
  send_rail_transfiya_hint: "A una cuenta bancaria",
  send_recipient_label: "¿Quién recibe?",
  send_key_label: "Llave Bre-B de quien recibe",
  send_key_placeholder: "Celular, correo, documento o @llave",
  send_key_hint: "Escríbela tal como te la dieron; nosotros reconocemos qué tipo de llave es.",
  send_key_as_written: "Escríbela exactamente como está registrada, sin espacios, puntos ni +57.",
  send_key_type_line: "Llave: {{type}}",
  send_tf_name_label: "Nombre del titular de la cuenta",
  send_tf_name_placeholder: "Como aparece en el banco",
  send_tf_name_error: "Escribe el nombre del titular",
  send_concept_label: "Concepto (opcional)",
  send_review: "Revisar envío",
  send_cancel: "Cancelar",
  send_close: "Cerrar",
  send_read_only:
    "Puedes ver esta billetera, pero tu usuario no tiene permiso para enviar dinero. Pídeselo a un administrador de tu organización.",
  send_review_title: "Revisa y confirma",
  send_review_arrives_to: "Llega a",
  send_review_key: "Llave",
  send_review_bank: "Banco",
  send_review_account: "Cuenta",
  send_review_document: "Documento",
  send_review_via: "Vía",
  send_review_concept: "Concepto",
  send_review_edit: "Editar",
  send_confirm: "Enviar {{amount}}",
  send_cost_changed: "El costo del envío cambió mientras revisabas. Revisa los valores antes de enviar.",
  send_converts_hint: "Convertimos tus {{from}} a {{to}} dentro del envío, a la tasa que ves abajo.",
  send_amount_label_arrives: "¿Cuánto debe recibir la persona?",
  send_amount_label_debit: "¿Cuánto sale de tu billetera?",
  send_fee_on_hint_fx:
    "Escribes lo que recibe la persona en {{currency}}; el costo y la conversión se suman a lo que sale.",
  send_fee_off_hint_fx:
    "Escribes lo que sale de tu billetera en {{currency}}; el costo y la conversión se descuentan de lo que llega.",
  send_row_conversion: "Conversión",
  send_rate_label: "Tipo de cambio",
  send_rate_valid_for: "Precio válido por {{time}}",
  send_rail_pix_hint: "Al instante, a una llave PIX",
  send_rail_spei_hint: "A una cuenta CLABE",
  send_rail_cbu_cvu_hint: "A un CBU o un CVU",
  send_name_label: "Nombre de quien recibe",
  send_name_placeholder: "Nombre completo o razón social",
  send_pix_key_hint: "Pégala tal como te la dieron; reconocemos el tipo de llave.",
  send_pix_key_check_error: "Revisa el número: los dígitos verificadores no coinciden.",
  send_clabe_check_error: "Revisa la CLABE: el dígito verificador no coincide.",
  send_rfc_label: "RFC",
  send_rfc_placeholder: "12 o 13 caracteres",
  send_rfc_helper: "Opcional. Si es una empresa, su RFC de 12 caracteres.",
  send_rfc_error: "Revisa el RFC: 12 caracteres para una empresa, 13 para una persona.",
  send_review_rfc: "RFC",
  send_transit_from: "Tu billetera {{currency}}",
  send_transit_aria: "Enviando {{amount}} a {{name}} en {{country}}",
  send_transit_aria_fx: "Enviando {{debit}}, convertidos a {{amount}}, a {{name}} en {{country}}",
  send_processing_fx: "Convirtiendo tus {{from}} a {{to}} y enviando…",
};
